export default "__VITE_ASSET__UYbOWs3___"